import React from 'react';
import { View, Image } from 'react-native';

import { relicSheetFor } from 'images/RelicVault';
import { IS_WEB, webOnly } from 'utils/relicVault/webStyle';

// Each sheet is a 3x2 grid of 160x160 icons (480x320 total).
const ICON = 160;
const SHEET_W = 480;
const SHEET_H = 320;

const parseOffset = bgPos => {
  const [x = 0, y = 0] = String(bgPos || '')
    .split(' ')
    .map(part => parseFloat(part) || 0);
  return { x, y };
};

/**
 * One relic icon cut out of its sprite sheet.
 *
 * The design positions icons with CSS background-position; here the whole sheet
 * is an Image inside a clipped box, offset so only this icon shows. `size` is
 * the rendered icon size in px (the design's 160px icon scaled).
 *
 * `locked` draws the uniform white silhouette used for undiscovered relics.
 * `shadow` adds the design's drop shadow (web only).
 */
const RelicSprite = ({ relic, size, locked = false, shadow = 'rgba(0,0,0,0.4)', style }) => {
  const source = relicSheetFor(relic?.sheetClass);
  if (!source) return <View style={[{ width: size, height: size }, style]} />;

  const k = size / ICON;
  const { x, y } = parseOffset(relic.bgPos);

  // Web: CSS filters give the exact silhouette + drop shadow from the design.
  // Native: tintColor flattens the icon to white for the silhouette.
  const imageEffects = locked
    ? IS_WEB
      ? { filter: 'brightness(0) invert(1)', opacity: 0.55 }
      : { tintColor: '#FFFFFF', opacity: 0.55 }
    : webOnly(
        shadow
          ? { filter: `drop-shadow(0 ${6 * k}px ${12 * k}px ${shadow})` }
          : null,
      );

  return (
    <View
      pointerEvents="none"
      style={[{ width: size, height: size, overflow: 'hidden' }, style]}>
      <Image
        source={source}
        resizeMode="stretch"
        style={[
          {
            position: 'absolute',
            left: x * k,
            top: y * k,
            width: SHEET_W * k,
            height: SHEET_H * k,
          },
          imageEffects,
        ]}
      />
    </View>
  );
};

export default React.memo(RelicSprite);
